import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import Swal from 'sweetalert2';
import api3003 from '../../services/api3003';
import { useEffect } from 'react';


// Máscara CPF -> 000.000.000-00
const formatCPF = (value) => {
  value = value.replace(/\D/g, ""); // Remove tudo que não é número
  value = value.slice(0, 11); // Máximo 11 dígitos
  return value
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
};

// Máscara CNPJ -> 00.000.000/0000-00
const formatCNPJ = (value) => {
  value = value.replace(/\D/g, "");
  value = value.slice(0, 14); // Máximo 14 dígitos
  return value
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
};

// Máscara Telefone -> (00) 00000-0000
const formatTelefone = (value) => {
  value = value.replace(/\D/g, "");
  value = value.slice(0, 11); // Máximo 11 dígitos
  return value
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d{1,4})$/, "$1-$2");
};

// Máscara IE -> 000.000.000.000 (12 dígitos)
const formatIE = (value) => {
  value = value.replace(/\D/g, ""); // Só dígitos
  value = value.slice(0, 12); // Máximo 12 dígitos
  return value
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,3})$/, "$1.$2");
};

// Validação IE (tem que ter 12 dígitos sem máscara)
const validateIE = (value) => {
  const digits = value.replace(/\D/g, "");
  return digits.length === 12;
};

// Validação IM (só dígitos, mínimo 1)
const validateIM = (value) => {
  return /^\d*$/.test(value); // permite vazio ou só dígitos
};



// Funções de validação
const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

const validateCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
  let soma = 0, resto;

  for (let i = 1; i <= 9; i++) soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;
  if ((resto === 10) || (resto === 11)) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;

  soma = 0;
  for (let i = 1; i <= 10; i++) soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if ((resto === 10) || (resto === 11)) resto = 0;
  return resto === parseInt(cpf.substring(10, 11));
};

const validateCNPJ = (cnpj) => {
  cnpj = cnpj.replace(/[^\d]+/g, '');
  if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0, pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado !== parseInt(digitos.charAt(0))) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  return resultado === parseInt(digitos.charAt(1));
};

const validateTelefone = (telefone) => {
  const regex = /^\(?\d{2}\)?\s?\d{4,5}-?\d{4}$/; // Formatos (11) 99999-9999 ou 11999999999
  return regex.test(telefone);
};

// Animação
const fadeScaleIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.7);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Modal = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px 30px;
  width: 600px;
  max-width: 90%;
  animation: ${fadeScaleIn} 0.3s ease-out;
  box-shadow: 0 8px 20px rgba(0,0,0,0.25);
`;

const Title = styled.h2`
  margin-bottom: 20px;
  text-align: center;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const Form = styled.form``;

const Input = styled.input`
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  font-size: 14px;
  &:focus {
    border-color: #3085d6;
    outline: none;
    box-shadow: 0 0 0 2px rgba(51, 153, 255, 0.2);
  }
`;

const Textarea = styled.textarea`
  grid-column: span 2;
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  font-size: 14px;
  resize: vertical;
  &:focus {
    border-color: #3085d6;
    outline: none;
    box-shadow: 0 0 0 2px rgba(51, 153, 255, 0.2);
  }
`;

const ButtonRow = styled.div`
  grid-column: span 2;
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
`;

const Button = styled.button`
  padding: 10px 20px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.2s ease;
  background: ${(props) => (props.primary ? '#3085d6' : '#dcdcdc')};
  color: ${(props) => (props.primary ? '#fff' : '#000')};

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
    opacity: 0.8;
  }
`;

const ToggleWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

const ToggleContainer = styled.div`
  position: relative;
  width: 120px;
  height: 30px;
  background: #f1f1f1;
  border-radius: 30px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }
`;

const ToggleBall = styled.div`
  position: absolute;
  width: 60px;
  height: 30px;
  border-radius: 20px;
  background: #3085d6;
  transition: all 0.3s ease;
  left: ${props => (props.active === "CPF" ? "5px" : "65px")};
`;

const ToggleLabel = styled.div`
  flex: 1;
  text-align: center;
  font-weight: bold;
  z-index: 1;
  color: ${props => (props.active ? "#fff" : "#000000")};
`;

const ClientFormCreate = ({ onClose, onCreated, client = {} }) => {
  const [form, setForm] = useState({
    nome: client.nome || "",
    inscricaoEstadual: client.inscricao_estadual || "",
    inscricaoMunicipal: client.inscricao_municipal || "",
    endereco: client.endereco || "",
    cpf: client.cpf || "",
    cnpj: client.cnpj || "",
    telefone: client.telefone || "",
    email: client.email || "",
    observacao: client.observacao || ""
  });

  const [tipe, setTipe] = useState(client.tipo_documento || "CPF");

  useEffect(() => {
    if (client.cpf) {
      setForm(prev => ({ ...prev, cpf: formatCPF(client.cpf) }));
    }
  }, [client.cpf]);
  

  const handleChange = e => {
    let { name, value } = e.target;

    const limits = {
      nome: 150,
      email: 150,
      endereco: 255,
      telefone: 20,
      cpf: 14,
      cnpj: 18,
      inscricaoEstadual: 30,
      inscricaoMunicipal: 30,
      observacao: 1000
    };

    if (name === "cpf") value = formatCPF(value);
    if (name === "cnpj") value = formatCNPJ(value);
    if (name === "telefone") value = formatTelefone(value);
    if (name === "inscricaoEstadual") value = formatIE(value);
    if (name === "inscricaoMunicipal") value = value.replace(/\D/g, "");

    // 🔥 trava tamanho
    if (limits[name] && value.length > limits[name]) return;

    setForm({ ...form, [name]: value });
  };
  
  const handleCpfBlur = (e) => {
    const formatted = formatCPF(e.target.value);
    setForm((prev) => ({ ...prev, cpf: formatted }));
  };  

  const handleCnpjBlur = (e) => {
    const formatted = formatCNPJ(e.target.value);
    setForm((prev) => ({ ...prev, cnpj: formatted }));
  };
  
  const handleSubmit = async e => {
    e.preventDefault();

    if (!form.nome) {
      Swal.fire({ icon: 'error', title: 'Campo obrigatório', text: 'O campo Nome é obrigatório!' });
      return;
    }

    if (!form.cpf && !form.cnpj) {
      Swal.fire({ icon: 'error', title: 'Documento obrigatório', text: 'Informe pelo menos CPF ou CNPJ!' });
      return;
    }

    if (form.cpf && !validateCPF(form.cpf)) {
      Swal.fire({ icon: 'error', title: 'CPF inválido', text: 'Digite um CPF válido!' });
      return;
    }

    if (form.cnpj && !validateCNPJ(form.cnpj)) {
      Swal.fire({ icon: 'error', title: 'CNPJ inválido', text: 'Digite um CNPJ válido!' });
      return;
    }

    if (form.email && !validateEmail(form.email)) {
      Swal.fire({ icon: 'error', title: 'Email inválido', text: 'Digite um email válido!' });
      return;
    }

    if (form.telefone && !validateTelefone(form.telefone)) {
      Swal.fire({ icon: 'error', title: 'Telefone inválido', text: 'Digite um telefone válido!' });
      return;
    }
    
    if (form.inscricaoEstadual && !validateIE(form.inscricaoEstadual)) {
      Swal.fire({ icon: 'error', title: 'IE inválida', text: 'A Inscrição Estadual deve ter 12 dígitos!' });
      return;
    }
    
    if (form.inscricaoMunicipal && !validateIM(form.inscricaoMunicipal)) {
      Swal.fire({ icon: 'error', title: 'IM inválida', text: 'A Inscrição Municipal deve conter apenas números!' });
      return;
    }
    

    try {
      const token = localStorage.getItem("token");

      const basePayload = {
        nome: form.nome,
        endereco: form.endereco,
        telefone: form.telefone,
        email: form.email,
        observacao: form.observacao,
        inscricao_estadual: "",
        inscricao_municipal: "",
        cpf: "",
        cnpj: "",
        tipo_documento: tipe
      };

      const payload =
        tipe === "CPF"
          ? {
              ...basePayload,
              cpf: form.cpf ? form.cpf.replace(/\D/g, "") : ""
            }
          : {
              ...basePayload,
              cnpj: form.cnpj ? form.cnpj.replace(/\D/g, "") : "",
              inscricao_estadual: form.inscricaoEstadual || "",
              inscricao_municipal: form.inscricaoMunicipal || ""
            };
    
      if (client?.id) {
        await api3003.put(`/api/clients/${client.id}`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        Swal.fire({ icon: "success", title: "Sucesso!", text: "Cliente atualizado com sucesso!", timer: 1800, showConfirmButton: false });
      } else {
        await api3003.post("/api/clients", payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        Swal.fire({ icon: "success", title: "Sucesso!", text: "Cliente criado com sucesso!", timer: 1800, showConfirmButton: false });
      }
    
      onCreated();
      onClose();
    
    }  catch (err) {

  const data = err.response?.data;

  if (data?.field === "cpf") {
    return Swal.fire({
      icon: "error",
      title: "CPF duplicado",
      text: data.error
    });
  }

  if (data?.field === "cnpj") {
    return Swal.fire({
      icon: "error",
      title: "CNPJ duplicado",
      text: data.error
    });
  }

  Swal.fire({
    icon: "error",
    title: "Erro",
    text: data?.error || err.message || "Erro ao salvar cliente"
  });

}
  };

  return (
    <Overlay>
      <Modal>
        <Title>{client.nome ? "Edição" : "Cadastro"} de Cliente</Title>

        <Form onSubmit={handleSubmit}>
          <ToggleWrapper>
            <ToggleContainer onClick={() => setTipe(tipe === "CPF" ? "CNPJ" : "CPF")}>
              <ToggleBall active={tipe} />
              <ToggleLabel active={tipe === "CPF"}>CPF</ToggleLabel>
              <ToggleLabel active={tipe === "CNPJ"}>CNPJ</ToggleLabel>
            </ToggleContainer>
          </ToggleWrapper>

          {tipe === "CPF" && (
            <FormGrid>
              <Input
                name="cpf"
                value={form.cpf}
                onChange={handleChange}
                placeholder="CPF"
                autoComplete="off"
                onBlur={handleCpfBlur}
                maxLength={14}
              />

              <Input
                name="nome"
                value={form.nome}
                onChange={handleChange}
                placeholder="Nome"
                maxLength={150}
              />

              <Input
                name="endereco"
                value={form.endereco}
                onChange={handleChange}
                placeholder="Endereço"
                maxLength={255}
              />

              <Input
                name="telefone"
                value={form.telefone}
                onChange={handleChange}
                placeholder="Telefone"
                maxLength={20}
              />

              <Input
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Email"
                maxLength={150}
              />

              <Textarea
                name="observacao"
                value={form.observacao}
                onChange={handleChange}
                placeholder="Observação"
                maxLength={1000}
              />
            </FormGrid>
          )}

          {tipe === "CNPJ" && (
            <FormGrid>
              <Input
                name="cnpj"
                value={form.cnpj}
                onChange={handleChange}
                placeholder="CNPJ"
                autoComplete="off"
                onBlur={handleCnpjBlur}
                maxLength={18}
              />

              <Input
                name="nome"
                value={form.nome}
                onChange={handleChange}
                placeholder="Razão Social"
                maxLength={150}
              />

              <Input
                name="inscricaoEstadual"
                value={form.inscricaoEstadual}
                onChange={handleChange}
                placeholder="Inscrição Estadual (IE)"
                maxLength={30}
              />

              <Input
                name="inscricaoMunicipal"
                value={form.inscricaoMunicipal}
                onChange={handleChange}
                placeholder="Inscrição Municipal (IM)"
                maxLength={30}
              />

              <Input
                name="endereco"
                value={form.endereco}
                onChange={handleChange}
                placeholder="Endereço"
                maxLength={255}
              />

              <Input
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Email"
                maxLength={150}
              />

              <Input
                name="telefone"
                value={form.telefone}
                onChange={handleChange}
                placeholder="Telefone"
                maxLength={20}
              />

              <Textarea
                name="observacao"
                value={form.observacao}
                onChange={handleChange}
                placeholder="Observação"
                maxLength={1000}
              />
            </FormGrid>
          )}

          <ButtonRow>
            <Button type="button" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit" primary>
              {client.nome ? "Editar" : "Criar"}
            </Button>
          </ButtonRow>
        </Form>
      </Modal>
    </Overlay>
  );
};

export default ClientFormCreate;
